import { Transition } from './enums';
import { isOS } from './helpers';

const resets = {
  '@global': {
    '*': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      '& [data-reach-custom-checkbox-container]:focus-within, [data-reach-custom-checkbox-container][data-focus]':
        {
          boxShadow: 'none',
          outline: 'none',
        },
    },
    'button, input, select, textarea': {
      '-webkit-tap-highlight-color': 'rgba(255, 255, 255, 0) !important',
      '-webkit-focus-ring-color': 'rgba(255, 255, 255, 0) !important',
      outline: 'none !important',
    },
    html: {
      minHeight: '-webkit-fill-available',
      tapHighlightColor: 'transparent',
      fontSmoothing: 'antialiased',
      textRendering: 'optimizeLegibility',
      fontFeatureSettings: 'normal',
      '-webkit-text-size-adjust': 'none',
      [isOS()]: {
        '-webkit-overflow-scrolling': 'auto',
      },
    },
    a: {
      textDecoration: 'none',
    },
    'input, button, textarea, select': {
      fontFamily: 'inherit',
    },
  },
};

export function pristineLinks(
  initialColor = 'var(--x-accent-1-1)',
  hoverActiveColor = 'var(--x-accent-1-2)',
) {
  return {
    '@global': {
      a: {
        '&:not([class])': {
          color: initialColor,
          transition: `color ${Transition.Default} ease-in-out`,

          '&:hover': {
            color: hoverActiveColor,
          },
          '&:active': {
            color: hoverActiveColor,
          },
        },
      },
    },
  };
}

export default resets;
